// from elemental ui

import React, { Component } from 'react';
import { width, fractions, breakpoint } from './constants';
import { omit } from 'lodash';

export default class Col extends Component {
  static defaultProps = {
    gutter: width.gutter
  };

  state = {
    windowWidth: window.innerWidth
  };

  // componentDidMount() {
  //   window.addEventListener('resize', ::this.handleResize);
  // }

  // componentWillUnmount() {
  //   window.removeEventListener('resize', ::this.handleResize);
  // }

  // handleResize() {
  //   this.setState({ windowWidth: window.innerWidth });
  // }

  render() {
    const { basis, gutter, xs, sm, md, lg, vertical, width } = this.props;
    const { windowWidth } = this.state;

    const columnStyle = {
      paddingLeft: (gutter / 2),
      paddingRight: (gutter / 2),
    };

    // if no width control is provided fill available space
    if (!basis && !xs && !sm && !md && !lg) {
      columnStyle.flex = '1 1 auto';
      columnStyle.msFlex = '1 1 auto';
      columnStyle.WebkitFlex = '1 1 auto';
    }

    // set widths / flex-basis
    if (basis) {
      columnStyle.flex = '1 0 ' + basis;
      columnStyle.msFlex = '1 0 ' + basis;
      columnStyle.WebkitFlex = '1 0 ' + basis;
    } else if (windowWidth < breakpoint.xs) {
      columnStyle.width = xs;
    } else if (windowWidth < breakpoint.sm) {
      columnStyle.width = sm || xs;
    } else if (windowWidth < breakpoint.md) {
      columnStyle.width = md || sm || xs;
    } else {
      columnStyle.width = lg || md || sm || xs;
    }

    if (!columnStyle.width) {
      columnStyle.width = width || '100%';
    }

    if (columnStyle.width in fractions) {
      columnStyle.width = fractions[columnStyle.width];
    }

    if (vertical) {
      columnStyle.display = 'flex';
      columnStyle.justifyContent = vertical;
      columnStyle.flexDirection = 'column';
    }

    let props = omit(this.props, 'basis', 'gutter', 'vertical', 'justifyContent', 'style', 'xs', 'sm', 'md', 'lg');

    return (
      <div
        className="Col"
        style={Object.assign(columnStyle, this.props.style)}
        {...props}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/col.js